import { IMotoristaRepository } from '../repositories/IMotoristaRepository'

export interface IGetImagemMotorista {
  execute(id: number): Promise<string>
}

export default class GetImagemMotoristaImpl implements IGetImagemMotorista {
  constructor(private readonly motoristasRepository: IMotoristaRepository) {}

  public async execute(id: number): Promise<string> {
    return await this.motoristasRepository.getImagemMotorista(id)
  }
}
